export default function Reports() {
  return (
    <div className="page-content">
      <h2>Reports</h2>
      <p>Reports page is coming soon.</p>
    </div>
  );
}